import { createSlice } from '@reduxjs/toolkit';

import { ICompareFlightTooltipState } from '../../types/redux';

const initialState: ICompareFlightTooltipState = {
  isCompareFlightTooltipShow: false,
};

export const compareFlightTooltipSlice = createSlice({
  name: 'compareFlightTooltip',
  initialState,
  reducers: {},
});

export const { reducer: compareFlightTooltipReducer } = compareFlightTooltipSlice;
